<template>
  <div class="pageDiv">
    <div class="loader" v-if="$CommandSvc.isBusy()"></div>

    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Score Card</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && !scoreIsReady">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Score Card</span>
      </v-card-title>

      <v-card-text v-if="tournaments.length > 1">
        <v-card-title>
            Select course to show Score Card:
        </v-card-title>

        <v-card-text>
            <div v-for="tn in tournaments" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
                <div class="select-btn" @click="selectTournament(tn)">
                  <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                    {{printDateTime(tn.tournament.scheduleDate)}}
                  </span>
                    <span style="display:inline-block;padding-top:7px;text-align:left;">
                    {{tn.course!==null?tn.course.name:''}}
                  </span>
                    <span> ({{$AuthSvc.printFormat(tn.tournament.formatType)}}) </span>
                </div>
            </div>
        </v-card-text>
    </v-card-text>
    <v-card-text v-if="tournaments.length === 0">
      <span class="label14">
       No tournament is active to show Score Card.
      </span>
    </v-card-text>
    </v-card>


    <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreIsReady">
      <v-card-text>
        <span class="label16">{{ tournament.course.name }}</span><br/><br/>
      </v-card-text>

      <v-card-text>
        <a href="/images/common/DFWVGA_Tournament_Rules.pdf" class="label16">
          DFWVGA Tournament Rules
        </a>
        <br>
        <br>
      </v-card-text>

      <v-tabs>
        <v-tab @click="selectMenu(0)">Score</v-tab>
        <v-tab @click="selectMenu(1)">Leader</v-tab>
        <v-tab @click="selectMenu(2)">Birdie</v-tab>
        <v-tab @click="selectMenu(3)" v-if="hasTeamMatches() || hasSingleMatches()">CUP</v-tab>
      </v-tabs>

      <v-card  v-if="selectedMenu === 0">
        <v-card class="player-info">
          <v-title class="player-label">
            <div class="titleDiv">
              <div class="leftDiv">
                Group {{playerScores[0].groupId}}
              </div>

              <div class="rightDiv">
                <span>Hole Started: </span>
                <select class="dropdown" v-model="playerScores[0].holeStart"
                  @change="updateGroupHoleStart(playerScores[0].groupId, playerScores[0].holeStart)">
                  <option value="0">N/A</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                </select>
              </div>
            </div>

          </v-title>

          <v-card-text style="margin-top: 10px" v-if="['TOURNAMENT','FUN', 'FUN_FW', 'FUN_FW_TEAM'].includes(tournament.formatType)">
            <ul>
              <li>
                <span style="display:inline-block;width:200px;" class="label">Player Names</span>
                <spa n style="display:inline-block;width:60px" class="label">Score</spa>
                <span class="label">Thru</span>
              </li>
              <li v-for="playerScore in playerScores" :key="playerScore.playerId">
                  <span style="display:inline-block;width:200px" class="label14" v-if="playerScore.firstName!=='N/A'">
                    {{ getName(playerScore) }}
                  </span>
                <span style="display:inline-block;width:60px" class="label18" v-if="playerScore.firstName!=='N/A'">
                    {{printScore(playerScore)}}
                  </span>
                <span class="label18" v-if="playerScore.firstName!=='N/A'">
                    {{printThru(playerScore)}}
                  </span>
              </li>
            </ul>
          </v-card-text>

          <v-card-text style="margin-top: 10px" v-if="playerScores[0].matchPlay || ['MATCH_PLAY','FUN_FW_TEAM'].includes(tournament.formatType)">
            <v-simple-table class="score-card-table match-card" v-if="hasTeamMatches()">
              <tr>
                <th>{{tournament.homeTeam}} Team</th>
                <th>VS</th>
                <th>{{tournament.awayTeam}} Team</th>
                <th>Thru</th>
              </tr>
              <tr>
                <td>
                  {{ getName(playerScores[0]) }}
                  <br>
                  {{ getName(playerScores[1]) }}
                </td>
                <td>
                  <span class="label18">{{getMatchScore(playerScores[0])}}</span>
                </td>
                <td>
                  {{ getName(playerScores[2]) }}
                  <br>
                  {{ getName(playerScores[3]) }}
                </td>
                <td>
                  <span class="label18">{{getMatchThruHoles(playerScores[0])}}</span>
                </td>
              </tr>
            </v-simple-table>

            <v-simple-table class="score-card-table match-card" v-if="hasSingleMatches()">
              <tr>
                <th>{{tournament.homeTeam}} Player</th>
                <th>VS</th>
                <th>{{tournament.awayTeam}} Player</th>
                <th>Thru</th>
              </tr>
              <tr>
                <td>
                  {{ getName(playerScores[0]) }}
                </td>
                <td>
                  <span class="label18">{{playerScores[0].amatchScore===null?"A/S":playerScores[0].amatchScore}}</span>
                </td>
                <td>
                  {{ getName(playerScores[2]) }}
                </td>
                <td>
                  <span class="label18">
                    {{playerScores[0].thruHoles===18 || (playerScores[0].amatchScore !== null && playerScores[0].amatchScore.includes('&')) ?"F":playerScores[0].thruHoles}}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ getName(playerScores[1]) }}
                </td>
                <td>
                  <span class="label18">{{playerScores[1].amatchScore===null?"A/S":playerScores[1].amatchScore}}</span>
                </td>
                <td>
                  {{ getName(playerScores[3]) }}
                </td>
                <td>
                  <span class="label18">
                    {{playerScores[1].thruHoles===18 || (playerScores[1].amatchScore !== null && playerScores[1].amatchScore.includes('&'))?"F":playerScores[1].thruHoles}}
                  </span>
                </td>
              </tr>
            </v-simple-table>

          </v-card-text>

          <v-card-text style="margin-top: 10px" v-if="tournament.formatType=='2-SCRAMBLE'">
            <v-simple-table class="score-card-table match-card">
              <tr>
                <th>Team</th>
                <th>Score</th>
                <th>Thru</th>
              </tr>
              <tr>
                <td>
                  {{ getName(playerScores[0]) }}
                  <br>
                  {{ getName(playerScores[1]) }}
                </td>
                <td>
                  <span class="label18">{{playerScores[0].thruHoles===18?playerScores[0].score:playerScores[0].toPar}}</span>
                </td>
                <td>
                  <span class="label18">{{playerScores[0].thruHoles===18?'F':playerScores[2].thruHoles}}</span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ getName(playerScores[2]) }}
                  <br>
                  {{ getName(playerScores[3]) }}
                </td>
                <td>
                  <span class="label18">{{playerScores[2].thruHoles===18?playerScores[2].score:playerScores[2].toPar}}</span>
                </td>
                <td>
                  <span class="label18">{{playerScores[2].thruHoles===18?'F':playerScores[2].thruHoles}}</span>
                </td>
              </tr>
            </v-simple-table>
          </v-card-text>

        </v-card>

        <v-card v-if="['TOURNAMENT','MATCH_PLAY','FUN', 'FUN_FW', 'FUN_FW_TEAM'].includes(tournament.formatType)">
          <v-simple-table class="score-card-table" :disabled="isOpen===true">
            <tr>
              <th width="5%">Hole</th>
              <th width="5%">PAR</th>
              <th v-for="score in playerScores" :key="score.playerId">
                {{score.firstName==='N/A'? '':getInitials(score)}}
              </th>
            </tr>

            <tr v-for="hole in frontHoles" :key="hole.hole">
              <td><span class="label18">{{hole.hole}}</span></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">{{hole.par}}</span></td>
              <td v-for="(score, index) in playerScores" :key="score.playerId"
                  @click="enterScore(hole, score, index)"
                  :class="{noScore: hole.scores[index]===0, enteringScore: hole.scores[index].selected, uneditable: score.firstName==='N/A',a_team: score.team == 'B'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[index].score, hole.par), scoreBogey: isBogey(hole.scores[index].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[index].score, hole.par), scoreDbogey: isDbogey(hole.scores[index].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[index].score < 10, scoreFont10:hole.scores[index].score>9}">{{hole.scores[index].score > 0 ? hole.scores[index].score : ''}}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="total-nine">
              <td></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">IN</span></td>
              <td><font class="scoreFont">{{playerScores[0].totalFront}}</font></td>
              <td><font class="scoreFont">{{playerScores[1].totalFront}}</font></td>
              <td><font class="scoreFont">{{playerScores[2].totalFront}}</font></td>
              <td><font class="scoreFont">{{playerScores[3].totalFront}}</font></td>
            </tr>
            <tr v-for="hole in backHoles" :key="hole.hole">
              <td><span class="label18">{{hole.hole}}</span></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">{{hole.par}}</span></td>
              <td v-for="(score, index) in playerScores" :key="score.playerId"
                  @click="enterScore(hole, score, index)"
                  :class="{noScore: hole.scores[index]===0, enteringScore: hole.scores[index].selected, uneditable: score.firstName==='N/A',a_team: score.team == 'B'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[index].score, hole.par), scoreBogey: isBogey(hole.scores[index].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[index].score, hole.par), scoreDbogey: isDbogey(hole.scores[index].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[index].score < 10, scoreFont10:hole.scores[index].score>9}">{{hole.scores[index].score > 0 ? hole.scores[index].score : ''}}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="total-nine">
              <td></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">OUT</span></td>
              <td><font class="scoreFont">{{playerScores[0].totalBack}}</font></td>
              <td><font class="scoreFont">{{playerScores[1].totalBack}}</font></td>
              <td><font class="scoreFont">{{playerScores[2].totalBack}}</font></td>
              <td><font class="scoreFont">{{playerScores[3].totalBack}}</font></td>
            </tr>
            <tr>
              <th width="20px">Hole</th>
              <th width="20px">PAR</th>
              <th v-for="score in playerScores" :key="score.playerId">
                {{score.firstName==='N/A'? '':getInitials(score)}}
              </th>
            </tr>
            <tr>
              <td></td>
              <td>Score</td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(0)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(1)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(2)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(3)}}</font></td>
            </tr>
            <tr>
              <td></td>
              <td>Thru</td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(0)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(1)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(2)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(3)}}</font></td>
            </tr>
          </v-simple-table>
        </v-card>

        <v-card v-if="tournament.formatType=='2-SCRAMBLE'">
          <v-simple-table class="score-card-table" :disabled="isOpen===true">
            <tr>
              <th width="5%">Hole</th>
              <th width="5%">PAR</th>
              <td>
                {{ getName(playerScores[0]) }}
                <br>
                {{ getName(playerScores[1]) }}
              </td>
              <td>
                {{ getName(playerScores[2]) }}
                <br>
                {{ getName(playerScores[3]) }}
              </td>
            </tr>

            <tr v-for="hole in frontHoles" :key="hole.hole">
              <td><span class="label18">{{hole.hole}}</span></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">{{hole.par}}</span></td>

              <td @click="enterScore(hole, playerScores[0], 0)"
                  :class="{noScore: hole.scores[0]===0, enteringScore: hole.scores[0].selected,
                     uneditable: playerScores[0].firstName==='N/A'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[0].score, hole.par), scoreBogey: isBogey(hole.scores[0].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[0].score, hole.par), scoreDbogey: isDbogey(hole.scores[0].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[0].score < 10, scoreFont10:hole.scores[0].score>9}">{{hole.scores[0].score > 0 ? hole.scores[0].score : ''}}</span>
                  </div>
                </div>
              </td>

              <td @click="enterScore(hole, playerScores[2], 0)"
                  :class="{noScore: hole.scores[2]===0, enteringScore: hole.scores[2].selected,
                     uneditable: playerScores[2].firstName==='N/A'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[2].score, hole.par), scoreBogey: isBogey(hole.scores[2].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[2].score, hole.par), scoreDbogey: isDbogey(hole.scores[2].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[2].score < 10, scoreFont10:hole.scores[2].score>9}">{{hole.scores[2].score > 0 ? hole.scores[2].score : ''}}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="total-nine">
              <td></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">IN</span></td>
              <td><font class="scoreFont">{{playerScores[0].totalFront}}</font></td>
              <td><font class="scoreFont">{{playerScores[2].totalFront}}</font></td>
            </tr>
            <tr v-for="hole in backHoles" :key="hole.hole">
              <td><span class="label18">{{hole.hole}}</span></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">{{hole.par}}</span></td>

              <td @click="enterScore(hole, playerScores[0], 0)"
                  :class="{noScore: hole.scores[0]===0, enteringScore: hole.scores[0].selected,
                     uneditable: playerScores[0].firstName==='N/A'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[0].score, hole.par), scoreBogey: isBogey(hole.scores[0].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[0].score, hole.par), scoreDbogey: isDbogey(hole.scores[0].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[0].score < 10, scoreFont10:hole.scores[0].score>9}">{{hole.scores[0].score > 0 ? hole.scores[0].score : ''}}</span>
                  </div>
                </div>
              </td>

              <td @click="enterScore(hole, playerScores[2], 0)"
                  :class="{noScore: hole.scores[2]===0, enteringScore: hole.scores[2].selected,
                     uneditable: playerScores[2].firstName==='N/A'}"
              >
                <div :class="{scoreBirdie: isBirdie(hole.scores[2].score, hole.par), scoreBogey: isBogey(hole.scores[2].score, hole.par)}">
                  <div :class="{scoreEagle: isEagle(hole.scores[2].score, hole.par), scoreDbogey: isDbogey(hole.scores[2].score, hole.par)}">
                    <span :class="{scoreFont: hole.scores[2].score < 10, scoreFont10:hole.scores[2].score>9}">{{hole.scores[2].score > 0 ? hole.scores[2].score : ''}}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="total-nine">
              <td></td>
              <td style="background-color: darkgreen;font-weight: bold;color: white;font-size: 16px;"><span class="label18">OUT</span></td>
              <td><font class="scoreFont">{{playerScores[0].totalBack}}</font></td>
              <td><font class="scoreFont">{{playerScores[2].totalBack}}</font></td>
            </tr>

            <tr>
              <td></td>
              <td>Score</td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(0)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateScore(2)}}</font></td>
            </tr>
            <tr>
              <td></td>
              <td>Thru</td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(0)}}</font></td>
              <td class="scores-row"><font class="scoreFont">{{calculateThru(2)}}</font></td>
            </tr>
          </v-simple-table>
        </v-card>

        <v-card>
          <div>
            <transition name="modal">
              <div v-if="isOpen">
                <div class="overlay" @click.self="isOpen = false;">
                  <div>
                    <v-card style="display:inline-block;padding:10px;width:380px;" class="etched-in">
                      <span class="score-enter">Hole #{{selectedHole.hole}} (Par {{selectedHole.par}}):</span><br>
                      <span class="label20">{{selectPlayerName}}</span><br><br>
                      <span class="label20">Enter Total Strokes:</span><br>

                      <div v-if="selectedHole.par === 3">
                        <button class="score1Btn" @click="selectScore(1)">
                          1 - Hole In One
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(2)">
                          2 - Birdie
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(3)">
                          3 - PAR
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(4)">
                          4 - Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(5)">
                          5 -  Double Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(6)">
                          6 - Max
                        </button>
                      </div>


                      <div v-if="selectedHole.par === 4">
                        <button class="score1Btn" @click="selectScore(1)">
                          1 - Albatross!!!
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(2)">
                          2 - Eagle
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(3)">
                          3 - Birdie
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(4)">
                          4 - PAR
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(5)">
                          5 - Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(6)">
                          6 - Double Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(7)">
                          7 - Triple Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(8)">
                          8 - Max
                        </button>
                      </div>

                      <div v-if="selectedHole.par === 5">
                        <button class="score1Btn" @click="selectScore(2)">
                          2 - Albatross!!!
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(3)">
                          3 - Eagle
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(4)">
                          4 - Birdie
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(5)">
                          5 - PAR
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(6)">
                          6 - Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(7)">
                          7 - Double Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(8)">
                          8 - Triple Bogey
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(9)">
                          9 - Quadruple
                        </button>
                        <br>
                        <button class="score1Btn" @click="selectScore(10)">
                          10 - Max
                        </button>
                      </div>
                      <br>

                      <button class="clear-cancel" @click="selectScore(0)">
                        Clear
                      </button>
                      <button></button>
                      <button class="clear-cancel" @click="selectScore('')">
                        Cancel
                      </button>
                    </v-card>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </v-card>
      </v-card>

      <v-card  v-if="selectedMenu === 1">
        <v-card class="feedback-card mx-auto mt-5" v-if="$AuthSvc.isFw() && tournament !== null && ['FUN_FW','FUN_FW_TEAM'].includes(tournament.formatType)">
          <v-card-title>
            <h3 style="color:darkgreen;">Smack On!</h3>
          </v-card-title>

          <div class="feedback-text">
            <div class="feedback-card-text">
              <ul>
                <li v-for="feedback in feedbacks" :key="feedback.feedbackId">
                    <span style="font-size:14px;color:darkblue;">
                      {{feedback.userid}} {{printFBDateTime(feedback.postedTime)}}:
                    </span>
                  <span class="label18">{{feedback.message}}</span>
                </li>
              </ul>
            </div>

            <div class="fullwidth">
                <textarea class="enter-text" rows="1" v-model="message"
                          @keypress="processKey($event)"
                          contenteditable="true"
                />
              <button class="primary-btn" @click="postMessage()">Send</button>
            </div>

            <div class="fullwidth">
              <button class="emojiBtn" @click="addEmoji('😀')">😀</button>
              <button class="emojiBtn" @click="addEmoji('😁')">😁</button>
              <button class="emojiBtn" @click="addEmoji('😂')">😂</button>
              <button class="emojiBtn" @click="addEmoji('🤣')">🤣</button>
              <button class="emojiBtn" @click="addEmoji('😎')">😎</button>
              <button class="emojiBtn" @click="addEmoji('😇')">😇</button>
              <button class="emojiBtn" @click="addEmoji('😉')">😉</button>
              <button class="emojiBtn" @click="addEmoji('😜')">😜</button>
              <button class="emojiBtn" @click="addEmoji('😠')">😠</button>
              <button class="emojiBtn" @click="addEmoji('😢')">😢</button>
              <button class="emojiBtn" @click="addEmoji('😭')">😭</button>
              <button class="emojiBtn" @click="addEmoji('😩')">😩</button>
              <button class="emojiBtn" @click="addEmoji('😬')">😬</button>
              <button class="emojiBtn" @click="addEmoji('😳')">😳</button>
            </div>
          </div>
        </v-card>


        <v-card-text class="groupPairingCard" v-if="['MATCH_PLAY','FUN_FW_TEAM'].includes(tournament.formatType)">
          <div class="group-card" >
            <v-simple-table class="simple-table">
              <tr>
                <th>GROUP</th>
                <th>{{tournament.homeTeam}} Team</th>
                <th>VS</th>
                <th>{{tournament.awayTeam}} Team</th>
                <th>Thru</th>
              </tr>
              <tr v-for="group in groups" :key="group">
                <td>{{group.groupId}}</td>
                <td>{{group.aTeam[0]}} <br> {{group.aTeam[1]}}</td>
                <td>{{group.score === null || group.score === 0 ? "A/S" : group.score}}</td>
                <td>{{group.bTeam[0]}} <br> {{group.bTeam[1]}}</td>
                <td>{{group.thruHoles === 18 ? "F" : group.thruHoles}}</td>
              </tr>
            </v-simple-table>
          </div>
        </v-card-text>

        <v-simple-table class="score-card-table" v-if="['TOURNAMENT','MATCH_PLAY','FUN', 'FUN_FW', 'FUN_FW_TEAM'].includes(tournament.formatType)">
          <tr>
            <th>Rank</th>
            <th style="text-align:left">Player Name</th>
            <th>Score</th>
            <th>Thru</th>
          </tr>
          <tr v-for="leader in leaders" :key="leader">
            <td><span class="label18">{{leader.rank}}</span></td>
            <td style="text-align:left;padding: 0 10px;">
              <ul>
                <li v-for="name in leader.nameList" :key="name">
                  <span class="label18">{{name}}</span>
                </li>
              </ul>
            </td>
            <td><span class="label18">{{toScore(leader)}}</span></td>
            <td><span class="label18">{{leader.thruHoles===18 ? 'F' : leader.thruHoles}}</span></td>
          </tr>
        </v-simple-table>
      </v-card>

      <v-card  v-if="selectedMenu === 2" class="birdies-table">
        <v-card style="margin-top:10px;">
          <v-btn style="margin-right: 7px;" :class="{selectedFlight: birdieFlight==='Nicklaus'}" @click="selectBirdies('Nicklaus')">Nicklaus</v-btn>
          <v-btn style="margin-right: 7px;" :class="{selectedFlight: birdieFlight==='Palmer'}" @click="selectBirdies('Palmer')">Palmer</v-btn>
          <v-btn style="margin-right: 7px;" :class="{selectedFlight: birdieFlight==='Hogan'}" @click="selectBirdies('Hogan')">Hogan</v-btn>
        </v-card>

        <v-simple-table>
          <tr>
            <th width="60px">Hole</th>
            <th style="text-align:left">Birdies Players</th>
          </tr>
          <tr v-for="(birdie, index) in birdies" :key="birdie">
            <td>{{index+1}}</td>
            <td style="text-align:left; padding: 0 10px">{{birdie}}</td>
          </tr>
        </v-simple-table>
      </v-card>

      <v-card  v-if="selectedMenu === 3">
        <span class="label24" style="display:inline-block;margin:20px 10px">CUP Results</span>

        <div style="width:100%;height:40px;padding:0 10px">
          <div class="homeDiv">
              <span class="label16">{{tournament.homeTeam}}: </span>
              <span class="label18">{{homePointsFinal}}</span>
          </div>
          <div class="awayDiv">
            <span class="label16">{{tournament.awayTeam}}: </span>
            <span class="label18">{{awayPointsFinal}}</span>
          </div>
        </div>
        <div style="width:100%;height:40px;padding:0 10px">
          <div class="homeDiv">
            <span class="label16">Projected: </span>
            <span class="label18">{{homePoints}}</span>
          </div>
          <div class="awayDiv">
            <span class="label16">Projected: </span>
            <span class="label18">{{awayPoints}}</span>
          </div>
        </div>

        <div class="group-card" >
          <v-simple-table class="simple-table" v-if="hasTeamMatches()">
            <tr>
              <th>{{tournament.homeTeam}} Team</th>
              <th>VS</th>
              <th>{{tournament.awayTeam}} Team</th>
              <th width="10px">Thru</th>
            </tr>
            <tr v-for="group in groups" :key="group">
              <td>{{group.aTeam[0]}} <br> {{group.aTeam[1]}}</td>
              <td>{{group.score === null || group.score === 0 ? "A/S" : group.score}}</td>
              <td>{{group.bTeam[0]}} <br> {{group.bTeam[1]}}</td>
              <td :class="{finish: group.thruHoles === 18 || (group.score !== null && group.score.includes('&'))}">
                {{group.thruHoles === 18 || (group.score !== null && group.score.includes('&')) ? "F" : group.thruHoles}}
              </td>
            </tr>
          </v-simple-table>

          <v-simple-table class="simple-table" v-if="hasSingleMatches()">
            <tr>
              <th>{{tournament.homeTeam}} Player</th>
              <th>VS</th>
              <th>{{tournament.awayTeam}} Player</th>
              <th width="10px">Thru</th>
            </tr>
            <tr v-for="mt in singleMatches" :key="mt">
              <td>{{getName(mt[0])}}</td>
              <td>{{mt[0].amatchScore===null?'A/S' : mt[0].amatchScore}}</td>
              <td>{{getName(mt[1])}}</td>
              <td :class="{finish: mt[0].thruHoles === 18 || (mt[0].amatchScore !== null && mt[0].amatchScore.includes('&'))}">
                {{mt[0].thruHoles === 18 || (mt[0].amatchScore !== null && mt[0].amatchScore.includes('&')) ? "F" : mt[0].thruHoles}}
              </td>
            </tr>
          </v-simple-table>
        </div>
      </v-card>

      <v-card  v-if="selectedMenu === 4">
        <span class="label24" style="display:inline-block;margin:10px 0">Jackpot Prize: $500 Gift Card</span>

        <v-simple-table class="score-card-table">
          <tr>
            <th>Rank</th>
            <th style="text-align:left">Player Name</th>
            <th>Net</th>
            <th>Thru</th>
          </tr>
          <tr v-for="leader in leadersNet" :key="leader">
            <td><span class="label18">{{leader.rank}}</span></td>
            <td style="text-align:left;padding: 0 10px;"><span class="label18">{{getName(leader)}}</span></td>
            <td><span class="label18">{{toScoreNet(leader)}}</span></td>
            <td><span class="label18">{{leader.thruHoles===18 ? 'F' : leader.thruHoles}}</span></td>
          </tr>
        </v-simple-table>
      </v-card>

      <v-card class="submit-file-card" style="display:inline-block;" v-if="playerScores[0].thruHoles===18 && selectedMenu === 0">
        <div class="loader" v-if="isBusy"></div>
        <div v-if="!isBusy">
          <h2>Load Scorecard Image</h2>
          <hr/>
          <br/>
          <v-img class="score-card-img" :src="getFileName()">
          </v-img>
          <br/>
        </div>
        <div style="height: 170px;">
          <v-card-text style="padding:20px;">
            <span class="label16 listDiv">Take a picture of scorecard</span><br/>
            <input class="listDiv" type="file" @change="handleFileUpload( $event )"/>
          </v-card-text>
          <v-btn class="primary-btn listDiv" v-on:click="uploadScoreCard()">Upload</v-btn>
        </div>
      </v-card>
    </v-card>
  </div>
</template>


<script>
import moment from 'moment';
import swal from 'sweetalert';
import { getCurrentInstance } from 'vue';

  export default {
    name: "login",
    data: () => ({
      tournament: null,
      tournaments: [],
      leaders: [],
      leadersNet: [],
      isOpen: false,
      scoreIsReady: false,
      selectedScore: null,
      selectedHole: null,
      selectPlayer: -1,
      selectPlayerName: "",
      selectedMenu: 0,
      scoreValue: "",
      birdiesResp: null,
      birdies: [],
      playerSores: [],
      pars: [],
      frontHoles: [],
      backHoles: [],
      birdieFlight: '',
      file: null,
      imageFileName: '',
      isBusy: false,
      groups: [],
      singleMatches: [],
      subject: '',
      message: '',
      currentPost: null,
      feedbacks: [],
      homePoints: 0,
      awayPoints: 0,
      homePointsFinal: 0,
      awayPointsFinal: 0
    }),
    mounted: function() {
      var _this = this;

      _this.tournament = null;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
          if (data !== null) {
            _this.tournament = data.tournament;
            _this.tournament.course = data.course;
            window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
            _this.loadScoreCard(_this.tournament.tournamentId);
            _this.loadFeedbacks();
            _this.autoLoadFeedback();

          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/ACTIVE', function(data) {
            _this.tournaments = data;
            if (data.length === 1) {
              _this.tournament = data[0].tournament;
              _this.tournament.course = data[0].course;
              window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
              _this.loadScoreCard(_this.tournament.tournamentId);
              _this.loadFeedbacks();
              _this.autoLoadFeedback();
            }

            _this.tournaments.sort((a, b) => {
              if ( moment(a.tournament.scheduleDate).isAfter(b.tournament.scheduleDate) ) {
                return 1;
              }
              else {
                return -1;
              }
            });

        });
      }
    },
    methods: {
      addEmoji(ch) {
        this.message += ' ' + ch;
        console.log("MSG: " + this.message);
      },
      toggleEmojiPicker () {
        this.showEmojiPicker = !this.showEmojiPicker
      },
      isTournament(tournament) {
        if (tournament !== null) {
          return ['TOURNAMENT','MATCH_PLAY'].includes(tournament.formatType);
        }
        return null;
      },
      autoLoadFeedback() {
        setTimeout(() => {
          this.loadFeedbacks();
          this.$forceUpdate();
          this.autoLoadFeedback();
        }, 20000);
      },
      loadFeedbacks() {
        var _this = this;

        if (_this.isTournament(tournament) ) {
          _this.axios.get('/api/smack/' + this.tournament.tournamentId)
              .then(function (response) {
                _this.feedbacks = response.data;
              })
              .catch(function (error) {
                console.log('ERROR: ' + error);
              });
        }
      },
      processKey(event) {
        if (event.keyCode === 13) {
          this.postMessage();
        }
      },
      postMessage() {
        var _this = this;

        if (_this.message !== null && _this.message.length > 0) {
          var reply = {
            groupId: 0,
            postedTime: null,
            userid: _this.$AuthSvc.getNickName() !== null ? _this.$AuthSvc.getNickName() : _this.$AuthSvc.getUserid(),
            subject: '',
            message: this.message,
            tournamentId: _this.tournament.tournamentId
          };

          _this.axios.post('/api/feedbacks', reply)
              .then(function (response) {
                console.log(response.data);
                _this.loadFeedbacks();
                _this.message = '';
                this.$forceUpdate();
              })
              .catch(function (error) {
                console.log('ERROR: ' + error);
              });
        }
      },
      printFBDateTime(date) {
        return moment(date).format('hh:mm A');
      },
      printDateTime(date) {
        return moment(date).format('MM/DD hh:mm A');
      },
      selectTournament(tn) {
        window.location.href = "/scoring?id=" + tn.tournament.tournamentId;
      },
      loadScoreCard(tournamentId) {
        var _this = this;

        const urlParams = new URLSearchParams(window.location.search);
        const playerId = urlParams.get('playerId');
        if (playerId !== null && playerId !== '') {
          _this.loadCard(tournamentId, playerId);
        } else {
          _this.loadCard(tournamentId, _this.$AuthSvc.getUserInfo().playerId);
        }
      },
      loadCard(tournamentId, playerId) {
          var _this = this;

          _this.$CommandSvc.get(_this, '/api/scores/score-card/'+tournamentId+'/'+playerId,
            function (data) {
                console.log('DATA: ');
                _this.playerScores = data.playerScores;

                var pars = JSON.parse(data.pars);
                pars.splice(9,1);
                pars.splice(18,1);
                pars.splice(18,1);
                _this.pars = pars;

                var i;
                for (i=0; i < 9; i++) {
                  _this.frontHoles[i] = { hole: i+1,
                                     par: _this.pars[i],
                                     scores: []
                                   };
                  for (let j=0; j < _this.playerScores.length; j++) {
                    _this.frontHoles[i].scores.push({score: _this.playerScores[j].scores[i], selected: false});
                    _this.totalFront9(j);
                  }
                }


                var k=0;
                for (i=9; i < 18; i++, k++) {
                  _this.backHoles[k] = { hole: i+1,
                                     par: _this.pars[i],
                                     scores: []
                                   };
                  for (let j=0; j < _this.playerScores.length; j++) {
                    _this.backHoles[k].scores.push({score: _this.playerScores[j].scores[i], selected: false});
                    _this.totalBack9(j);

                  }
                }

                _this.scoreIsReady = true;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
      },
      hasSingleMatches() {
        return (this.tournament !== null && this.tournament.singleMatch === 'Y');
      },
      hasTeamMatches() {
        return (this.tournament !== null && this.tournament.teamMatch === 'Y');
      },
      loadGroups: function() {
        var _this = this;

        this.axios.get('/public/scores/score-card/group/' + this.tournament.tournamentId)
        .then(function (response) {
          _this.groups = new Array();
          _this.singleMatches = new Array();

          var p, g;
          var players = response.data;
          
          for(p=0; p < players.length; p++) {
            console.log(_this.getName(players[p]) + " " + players[p].matchPlay);
            if (players[p].matchPlay === 'N') {
              continue;
            }

            var foundGroup = -1;
            for(g=0; g < _this.groups.length; g++) {
                if (_this.groups[g].groupId === players[p].groupId) {
                  foundGroup = g;
                  break;
                }
            }

            var grp = null;

            if (foundGroup === -1 ) {
              grp = {
                groupId: players[p].groupId,
                aTeam: new Array(),
                bTeam: new Array(),
                aPlayers: new Array(),
                bPlayers: new Array(),
                score: '',
                thruHoles: 0
              };
              
              if (players[p].team === 'A') {
                grp.aTeam.push(_this.getName(players[p]));
                grp.score = players[p].matchScore;
                grp.thruHoles = players[p].thruHoles;
              }
              else {
                grp.bTeam.push(_this.getName(players[p]));
              }

              if (players[p].ateam === "1") {
                grp.aPlayers.push(players[p]);
              } else {
                grp.bPlayers.push(players[p]);
              }
              _this.groups.push(grp);
            }
            else {
              grp = _this.groups[foundGroup];
              if (players[p].team === 'A') {
                grp.aTeam.push(_this.getName(players[p]));
                grp.score = players[p].matchScore;
              }
              else {
                grp.bTeam.push(_this.getName(players[p]));
              }

              if (players[p].ateam === "1") {
                grp.aPlayers.push(players[p]);
              } else {
                grp.bPlayers.push(players[p]);
              }
            }
          }

          _this.singleMatches = new Array();
          for(var k=0; k < _this.groups.length; k++) {
            _this.singleMatches.push(_this.groups[k].aPlayers);
            _this.singleMatches.push(_this.groups[k].bPlayers);
          }

          _this.homePoints = 0.0;
          _this.awayPoints = 0.0;
          _this.homePointsFinal = 0.0;
          _this.awayPointsFinal = 0.0;

          var i;

          if (_this.hasTeamMatches()) {
            for (i=0; i < _this.groups.length; i++) {
              var grpScore = _this.groups[i].score;
              if (_this.groups[i].aPlayers[0].thruHoles > 0 && _this.groups[i].score === 'A/S') {
                _this.homePoints += 0.5;
                _this.awayPoints += 0.5;

                if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                  _this.homePointsFinal += 0.5;
                  _this.awayPointsFinal += 0.5;
                }
              }
              else if (_this.groups[i].aPlayers[0].thruHoles > 0 && (grpScore !== null && grpScore.includes('UP'))) {
                _this.homePoints += 1;
                if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                  _this.homePointsFinal += 1;
                }
              }
              else if (_this.groups[i].aPlayers[0].thruHoles > 0 && (grpScore !== null && grpScore.includes('DN'))) {
                _this.awayPoints += 1;
                if (_this.groups[i].aPlayers[0].thruHoles === 18 || (grpScore !== null && grpScore.includes('&'))) {
                  _this.awayPointsFinal += 1;
                }
              }
            }
          }

          if (_this.hasSingleMatches()) {
            for(i=0; i < _this.singleMatches.length; i++) {
              if (_this.singleMatches[i].length < 4) {
                continue;
              }

              var score = _this.singleMatches[i][0].amatchScore;
              if (_this.singleMatches[i][0].thruHoles > 0 && score === 'A/S') {
                _this.homePoints += 0.5;
                _this.awayPoints += 0.5;
                if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                  _this.homePointsFinal += 0.5;
                  _this.awayPointsFinal += 0.5;
                }
              }
              else if (_this.singleMatches[i][0].thruHoles > 0 && (score !== null && score.includes('UP'))) {
                _this.homePoints += 1;
                if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                _this.homePointsFinal += 1;
                }
              }
              else if (_this.singleMatches[i][0].thruHoles > 0 && (score !== null && score.includes('DN'))) {
                _this.awayPoints += 1;
                if (_this.singleMatches[i][0].thruHoles === 18 || (score !== null && score.includes('&'))) {
                _this.awayPointsFinal += 1;
                }
              }
            }
          }
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      loadLeaders: function() {
        var _this = this;
        var searchLeaders = "leaders";
        if (_this.tournament.formatType === '2-SCRAMBLE') {
          searchLeaders = "leaders-scramble";
        }

        _this.$CommandSvc.get(_this, '/api/scores/score-card/' + searchLeaders + '/' + _this.tournament.tournamentId,
          function (data) {
              var i;
              var list = data;
              var actualList = new Array();
              var unwantedList = new Array();
              var maxLeader = 0;
              for (i=0; i < list.length; i++)
              {
                if (list[i].thruHoles > maxLeader) {
                  maxLeader = list[i].thruHoles;
                }
              }

              var list2 = new Array();
              for (i=0; i < list.length; i++)
              {
                if (_this.tournament.formatType === '2-SCRAMBLE') {

                  var searchIdx = -1;
                  var j;
                  for(j=0; j < list2.length; j++) {
                    if (list2[j].groupId === list[i].groupId && list2[j].team === list[i].team) {
                      searchIdx = j;
                      break;
                    }
                  }

                  if (searchIdx > -1) {
                    list2[searchIdx].nameList.push(_this.getName(list[i]));
                  }
                  else {
                    var item = {
                      nameList: new Array(),
                      score: list[i].score,
                      groupId: list[i].groupId,
                      team: list[i].team,
                      toPar: list[i].toPar,
                      thruHoles: list[i].thruHoles
                    };
                    item.nameList.push(_this.getName(list[i]));

                    var found = false;
                    for(j=0; j < list2.length; j++) {
                      if (item.toPar < list2[j].toPar) {
                        list2.splice(j, 0, item);
                        found = true;
                        break;
                      }
                    }

                    if (!found) {
                      list2.push(item);
                    }
                  }
                }
                else {
                  var item2 = {
                    nameList: new Array(),
                    groupId: list[i].groupId,
                    team: list[i].team,
                    score: list[i].score,
                    toPar: list[i].toPar,
                    thruHoles: list[i].thruHoles
                  };
                  item2.nameList.push(_this.getName(list[i]));

                  list2.push(item2);
                }
              }

              for (i=0; i < list2.length; i++)
              {
                if (list[i].thruHoles > (maxLeader - 5)) {
                  actualList.push(list2[i]);
                }
                else {
                  unwantedList.push(list2[i] );
                }
              }

              _this.leaders = new Array();

              var rank = 0;
              for (i=0; i < actualList.length; i++)
              {
                rank++;
                actualList[i].rank = '' + rank;

                if (i > 0) {
                  if (actualList[i].score === actualList[i-1].score) {
                    if (actualList[i-1].rank.charAt(0) === 'T') {
                      actualList[i].rank = actualList[i-1].rank;
                    }
                    else {
                      actualList[i].rank = 'T' + actualList[i-1].rank;
                      actualList[i-1].rank = actualList[i].rank;
                    }
                  }
                }

                _this.leaders.push(actualList[i]);
              }

              for (i=0; i < unwantedList.length; i++)
              {
                unwantedList[i].rank = ' ';
                _this.leaders.push(unwantedList[i]);
              }

              console.log('DATA: ');
          },
          function (error) {
              console.log('ERROR: ' + error);
          });
      },
      loadLeadersNet: function() {
        var _this = this;

        _this.$CommandSvc.get(_this, '/api/scores/score-card/leaders-net/'+_this.tournament.tournamentId,
          function (data) {
              var i;
              var list = data;
              var actualList = new Array();
              var unwantedList = new Array();
              var maxLeader = 0;
              for (i=0; i < list.length; i++)
              {
                if (list[i].thruHoles > maxLeader) {
                  maxLeader = list[i].thruHoles;
                }
              }

              for (i=0; i < list.length; i++)
              {
                if (list[i].thruHoles > (maxLeader - 5)) {
                  actualList.push(list[i]);
                }
                else {
                  unwantedList.push(list[i]);
                }
              }

              _this.leadersNet = new Array();

              var rank = 0;
              for (i=0; i < actualList.length; i++)
              {
                rank++;
                actualList[i].rank = '' + rank;

                if (i > 0) {
                  if (actualList[i].score === actualList[i-1].score) {
                    if (actualList[i-1].rank.charAt(0) === 'T') {
                      actualList[i].rank = actualList[i-1].rank;
                    }
                    else {
                      actualList[i].rank = 'T' + actualList[i-1].rank;
                      actualList[i-1].rank = actualList[i].rank;
                    }
                  }
                }

                _this.leadersNet.push(actualList[i]);
              }

              for (i=0; i < unwantedList.length; i++)
              {
                unwantedList[i].rank = ' ';
                _this.leadersNet.push(unwantedList[i]);
              }

              console.log('DATA: ');
          },
          function (error) {
              console.log('ERROR: ' + error);
          });
      },
      loadBirdies() {
        var _this = this;
        _this.$CommandSvc.get(_this, '/api/scores/score-card/birdies/'+_this.tournament.tournamentId,
          function (data) {
              _this.birdiesResp = data;
              _this.birdies = _this.birdiesResp.nicklausBirdies;
              _this.birdieFlight = 'Nicklaus';
          },
          function (error) {
              console.log('ERROR: ' + error);
          });
      },
      selectMenu: function(menu) {
        this.selectedMenu = menu;

        if (menu === 0) {
          this.loadGroups();
        } else if (menu === 1) {
          this.loadLeaders();
       } else if (menu === 2) {
          this.loadBirdies();
        } else if (menu === 3) {
          this.loadGroups();
          this.loadLeadersNet();
        }

      },
      selectBirdies(flight) {
        if (flight === 'Nicklaus') {
          this.birdieFlight = 'Nicklaus';
          this.birdies = this.birdiesResp.nicklausBirdies;
        }
        else if (flight === 'Palmer') {
          this.birdieFlight = 'Palmer';
          this.birdies = this.birdiesResp.palmerBirdies;
        }
        else if (flight === 'Hogan') {
          this.birdieFlight = 'Hogan';
          this.birdies = this.birdiesResp.hoganBirdies;
        }
        else if (flight === 'Women') {
          this.birdieFlight = 'Women';
          this.birdies = this.birdiesResp.womenBirdies;
        }
      },
      getMatchScore(player) {
        if (player.matchPlay) {
          if (player.team === 'A') {
            if (player.matchScore === null || player.matchScore === 0) {
              return 'A/S';
            }
            else {
              return player.matchScore;
            }
          }
        }
        else {
          if (player.thruHoles < 18) {
            if (player.toPar > 0) {
              return "+" + player.toPar;
            }
            else {
              return player.toPar;
            }
          }
          else {
            player.score;
          }
        }
      },
      getMatchThruHoles(player) {
        if (player.matchPlay) {
          var score = player.matchScore;
          if (player.matchScore === null) {
            score = '';
          }
          return player.thruHoles === 18 || (score !== null && score.includes('&')) ? "F" : player.thruHoles;
        }
        else {
          return player.thruHoles === 18 ? "F" : player.thruHoles
        }
      },
      printScore(pScore) {
        var scr = '';
        if (pScore.thruHoles >= 18) {
          if (pScore.score===0) {
            scr = 'E';
          }
          else if (pScore.score > 0) {
            scr = pScore.score;
          }
          else {
            scr = pScore.score;
          }
        }
        else {
          if (pScore.toPar===0) {
            scr = 'E';
          }
          else if (pScore.toPar > 0) {
            scr = '+'+ pScore.toPar;
          }
          else {
            scr = pScore.toPar;
          }
        }

        return scr;
      },
      printThru(pScore) {
        if (pScore.thruHoles === 18) {
           return 'F';
        }
        else {
           return pScore.thruHoles;
        }
      },
      toScore(leader) {
        if (leader.thruHoles === 18) {
          return leader.score;
        } else {
          if (leader.toPar > 0 ) {
            return "+" + leader.toPar;
          } else if (leader.toPar === 0) {
            return "E";
          } else {
            return leader.toPar;
          }
        }
      },
      toScoreNet(leader) {
          return leader.score.toFixed(1);
      },

      getName(player) {
        if (player !==  null && player.firstName !== undefined) {
          if (['Guest','Vegas - '].includes(player.firstName)) {
            return player.nickName;
          }
          else if (this.isTournament(this.tournament) && this.$AuthSvc.isFw() && player.nickName !== null) {
            return player.nickName;
          }
          else {
            return player.firstName + " " +
                (player.middleName!==null && player.middleName!==''?player.middleName.charAt(0):'')
                + " " + player.lastName;
          }
        }
        return "";
      },
      getInitials(score) {
        if (score ===  null || score.firstName === undefined) {
          return "";
        }

        if (score.firstName === 'Guest' || score.firstName.startsWith('Vegas')) {
          if (score.nickName !== null) {
            return score.nickName.substring(0, 4);
          }
        }
        else {
          return "" +
              this.$AuthSvc.firstChar(score.firstName) +
              this.$AuthSvc.firstChar(score.middleName) +
              this.$AuthSvc.firstChar(score.lastName);
        }
        return "";
      },
      isEagle: function(score, par) {
        if (score > 0) {
          return (Number(score) < Number(par)-1);
        }
        return false;
      },
      isBirdie: function(score, par) {
        if (score > 0 ) {
          return (Number(score) < Number(par));
        }
        return false;
      },
      isBogey: function(score, par) {
        if (score > 0) {
          return (Number(score) > Number(par));
        }
        return false;
      },
      isDbogey: function(score, par) {
        if (score > 0) {
          return (Number(score) > Number(par+1));
        }
        return false;
      },
      calculateScore: function(player) {
        if (this.playerScores[player].firstName === 'N/A') {
          return '';
        }

        return this.printScore(this.playerScores[player]);
      },
      calculateThru: function(player) {
        if (this.playerScores[player].firstName === 'N/A') {
          return '';
        }

        return this.printThru(this.playerScores[player]);
      },
      totalFront9: function(player) {
        if (this.playerScores[player].firstName === 'N/A') {
          return '';
        }

        this.playerScores[player].totalFront = 0;
        for(var i=0; i < 9; i++) {
          this.playerScores[player].totalFront += this.playerScores[player].scores[i];
        }
      },
      totalBack9: function(player) {
        if (this.playerScores[player].firstName === 'N/A') {
          return '';
        }

        this.playerScores[player].totalBack = 0;
        for(var i=9; i < 18; i++) {
          this.playerScores[player].totalBack += this.playerScores[player].scores[i];
        }
      },
      updateGroupHoleStart(groupId, holeStart) {
          var _this = this;
          console.log('Call updateGroupHoleStart');
          let uri = '/api/scores/update-group-hole-start';
          const request = {
            tournamentId: _this.tournament.tournamentId,
            groupId: groupId,
            holeStart: Number(holeStart)
          };
          _this.axios.post(uri, request)
          .then(function() {
              console.log('Updated group : ');
          });
      },
      selectScore: function(score) {
        var _this = this;

        if (score !== '') {
          _this.scoreValue = score;
          _this.selectedHole.scores[_this.selectPlayer].score = score;

          const request = {
            tournamentId: _this.tournament.tournamentId,
            hole: this.selectedHole.hole,
            score: score,
            courseId: this.tournament.courseId
          };
          let uri = '/api/scores/score-card/' + _this.selectedScore.scoreCardId;
          console.log('URI: ' + uri);
          _this.axios.post(uri, request)
          .then(function (response) {
              console.log('Score updated: ' + _this.selectPlayer + ' ' + response.data);
              var playerData = response.data;
              _this.playerScores[_this.selectPlayer].score = playerData.score;
              _this.playerScores[_this.selectPlayer].toPar = playerData.toPar;
              _this.playerScores[_this.selectPlayer].thruHoles = playerData.thruHoles;
              _this.playerScores[_this.selectPlayer].scores[_this.selectedHole.hole-1] = score;

              _this.totalFront9(_this.selectPlayer);
              _this.totalBack9(_this.selectPlayer);

              if (_this.tournament.formatType === 'MATCH_PLAY') {
                console.log('MATCH PLAY');
              }

              _this.loadCard(playerData.tournamentId, playerData.playerId);
          });
        }

        this.isOpen = !this.isOpen;
        this.selectedHole.scores[this.selectPlayer].selected = false;
      },
      enterScore: function(hole, score, playerIndex) {
        if (score.firstName === 'N/A') {
          return;
        }

        if (this.isOpen && this.selectedScore !== null) {
          return;
        }

        hole.scores[playerIndex].selected = !hole.scores[playerIndex].selected;
        this.selectPlayer = playerIndex;
        this.selectPlayerName = score.firstName + ' ' +
          (score.middleName!==null && score.middleName!==''?score.middleName.charAt(0):'') + ' '
          + score.lastName;
        this.selectedHole = hole;
        this.selectedScore = score;

        this.isOpen = !this.isOpen;
      },
      handleFileUpload( event ){
        this.file = event.target.files[0];
      },
      uploadScoreCard() {
        var _this = this;

        _this.isBusy = true;

        let formData = new FormData();
        formData.append('file', this.file);

        this.axios.post( '/api/scores/load-score-card/'+this.tournament.tournamentId+'/'+this.playerScores[0].groupId,
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(){
          _this.$forceUpdate();
          _this.isBusy = false;
          swal("Success", "Score card has been loaded successfully.", "info")
           .then((willDelete) => {
              console.log("UPD: " + willDelete);
              window.location.reload();
           });
          console.log('SUCCESS!!');
        })
        .catch(function(error){
          _this.isBusy = false;
          swal("Problem", "Unable to load score card.", "error");
          console.log('FAILURE!! ' + error);
        });
      },
      forceUpdate() {
        const instance = getCurrentInstance();
        if (instance !== null) {
          instance.proxy.forceUpdate();
        }
      },
      isFinish() {
        var i;
        for(i=0; i < this.playerScores.length; i++) {
          if (this.playerScores[i].thruHoles !== 18) {
            return false;
          }
        }

        return true;
      },
      getFileName() {
        return '/images/score-card/'+this.tournament.tournamentId+'/'+this.playerScores[0].groupId;
      },
      minThru(players) {
        var minT = 18;
        for(var i=0; i < players.length; i++) {
          if (players[i].thruHoles < minT) {
            minT = players[i].thruHoles;
          }
        }
        return (minT===18)?"F":minT;
      }
    }
  }

</script>

<style scoped>
    .player-info {
      padding: 10px;
    }

    .player-label {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
    }

    .home-card {
        float: left;
    }

    .score-card-table {
        width: 98%;
        border: 2px solid #5c5747;
        box-shadow: 2px 2px 1px -1px #000;
        margin-bottom: 15px;
    }

    .birdies-table .v-tabs-bar {
      height: 18px;
    }

    .birdies-table .v-tab {
      font-size: 14px;
    }

    .v-tab {
      font-size: 12px !important;
      font-weight: bold;
    }

    .selectedFlight {
      background-color: #182e16 !important;
      color: white !important;
      font-weight: bold !important;
    }

    ul {
      list-style: none;
    }

    table {
       border:2px solid black;
    }

    th {
      height: 36px;
      background-color: #602e14;
      border: 1px solid aquamarine;
      box-shadow: 2px 2px 1px -1px #000;
      font-size: 12px;
      padding: 5px 10px;
      color: #f8eee8;
      text-align: center;
    }

    td {
        font-size: 12px;
        font-weight: bold;
        color: #2a2b1e;
        box-shadow:-2px -2px 1px -1px #000;
        padding: 8px 2px;
        text-align: center;
        vertical-align: middle;
    }

    .label {
        font-size: 16px;
        font-weight: bold;
        color: red;
    }

    @media (min-width: 391px) {
      th {
        font-size: 16px;
        padding: 5px 10px;
      }

      td {
          font-size: 14px;
      }

      .v-tab {
        font-size: 16px;
      }
    }

    .scoreBirdie {
      border: 2px solid;
      border-radius: 25px;
      padding: 2px;
      width: 41px;
      height: 41px;
    }

    .scoreBirdie > div {
      border-radius: 25px;
      padding: 0 9px;
      width: 33px;
      height: 33px;
    }

    .scoreEagle {
      border: 2px solid;
      padding: 0 7px !important;
    }

    .scoreBogey {
      border: 2px solid;
      padding: 0 2px;
      width: 44px;
      height: 41px;
    }

    .scoreBogey > div {
      padding: 4px 9px;
      width: 36px;
      height: 33px;
    }

    .scoreDbogey {
      border: 2px solid;
      padding: 0 7px !important;
      margin-top: 2px;
    }

    .scoreFont {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }

    .scoreFont10 {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }

    .scoreBtn {
      background-color: darkgreen;
      float: left;
      width: 60px;
      height: 60px;
      margin: 5px;
      border: 2px solid;
      border-radius: 7px;
      color: mintcream;
      font-size: xx-large;
      font-weight: bold;
    }

    .score1Btn {
      background-color: darkgreen;
      height: 45px;
      width: 96%;
      margin: 5px;
      border: 2px solid;
      border-radius: 7px;
      color: mintcream;
      font-size: x-large;
      font-weight: bold;
      padding: 0 12px 0 12px;
      text-align: left;
    }

    td > div {
      margin: auto;
    }

    .scores-row {
      text-align: center;
      vertical-align: middle;
      width: 90px;
    }

    .playerNames {
      display: inline-block;
      width: 200px;
      font-size: 16px;
      font-weight: bold;
    }

    .enterScoreTable {
      border: 2px solid;
    }

    .enterScoreTable > tr > td > button {
      margin: 2px !important;
    }

    .scoreInput {
      margin: 4px 0px;
      padding: 5px;
      border: 2px solid;
      height: 30px;
      width: 60px;
      text-align: center;
    }

    .saveBtn {
      margin-left: 10px;
      padding: 3px;
      border: 2px solid;
      height: 30px;
    }

    .modal {
      width: 360px;
      margin: 0px auto;
      padding: 20px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px 3px;
      transition: all 0.2s ease-in;
      font-family: Helvetica, Arial, sans-serif;
    }

    .fadeIn-enter {
      opacity: 0;
    }

    .fadeIn-leave-active {
      opacity: 0;
      transition: all 0.2s step-end;
    }

    .fadeIn-enter .modal,
    .fadeIn-leave-active.modal {
      transform: scale(1.1);
    }

    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #00000094;
      z-index: 999;
      transition: opacity 0.2s ease;
    }

    .enterScoreBtn {
      box-shadow: 1px 0px 1px -1px #000;
    }

    .noScore {
      background-color: lightgrey;
    }

    .enteringScore {
      background-color: red;
    }

    .v-data-table__wrapper {
      margin: 7px;
    }

    .etched-in {
      border:1px solid rgba(0,0,0,0.4);
      box-shadow:-2px -2px 2px -1px #000;
    }

    .etched-out {
      border:1px solid rgba(0,0,0,0.4);
      box-shadow:2px 2px 2px -1px #000;
    }

    .clear-cancel {
      float: left;
      width: 160px;
      height: 50px;
      padding: 0 12px 0 12px;
      font-size: 20px;
      font-weight: bold;
      margin: 5px;
      border: 2px solid;
      border-radius: 7px;
    }

    . class="birdies-flt" {
      float: left;
      margin-left: 7px;
    }

    .score-name {
      font-size: 24px;
      font-weight: bold;
    }

    .score-enter {
      font-size: xx-large;
      font-weight: bold;
    }

    .uneditable{
      background-color: lightgray;
      cursor: not-allowed;
    }

    .submit-file-card {
      padding: 20px;
    }

    .emojiBtn {
      font-size: 50px;
      margin-left: 15px;
    }

    @media (min-width: 768px) {
        .score-card-table {
            width: 490px;
        }

        td {
          font-size: 14px !important;
        }

        .score-card-img {
           width: 600px;
           height: 400px;
        }

        .enter-text {
          width: 93%;
        }

        .emojiBtn {
          font-size: 28px !important;
        }
    }

    .total-nine > td {
      background-color: lightgray;
      font-size: 24px !important;
      font-weight: bold;
    }

     .post {
      background-color: #dae0dd;
      padding: 5px !important;
      border-radius: 5px;
      width: 98% !important;
    }

    .first-message span {
      display: inline-block;
      width: 98%;
    }

    .reply-message span {
      display: inline-block;
      width: 98%;
      margin-left: 20px !important;
    }

    .post .v-card__text {
      padding: 0px !important;
      margin: 0px 5px!important;
    }


    input, textarea {
      display: inline-block;
      padding: 5px;
      border: 1px solid black;
      border-radius: 5px;
      width: 100%;
    }

    .feedback-card {
      display: inline-block;
      border: 1px solid black;
      border-radius: 5px;
      padding: 10px;
      width: 100%;
    }

    .feedback-card-text {
      display: flex;
      margin-top:10px !important;
      width:100%;
      height: 400px;
      padding: 5px 10px !important;
      overflow-y: scroll;
      flex-direction: column-reverse;
      border: 2px solid black;
      border-radius: 7px;
      margin-bottom: 7px;
    }

    .enter-text {
      display: inline-block;
      border: 3px solid black;
      width: 85%;
      font-size: 18px;
      font-weight: bold;
    }

    .primary-btn {
      display: inline-block;
      height: 36px;
      position: absolute;
      margin-left: 10px;
      padding: 5px 10px !important;
      border-radius: 8px;
    }


    .groupPairingCard {
      margin-bottom: 20px;
    }

  .member-table {
    margin-bottom: 15px;
  }

  .homeDiv, awayDiv {
    display: inline-block;
    width: 180px
  }

  .homeDiv {
    float: left;
  }

  .awayDiv {
    float: right;
  }

  .listDiv {
    display: inline-block;
    padding: 5px 10px;
    margin: 7px 0px;
  }

  .finish {
    background-color: lightgreen;
    font-size: 14px !important;
    font-weight: bold !important;
  }

  .titleDiv {
    display: inline-block;
    width: 540px;
    height: 80px;
  }

  .leftDiv {
    display: inline-block;
    width: 200px;
    float: left;
  }

  .rightDiv {
    display: inline-block;
    width: 200px;
    float: right;
    margin-right: 50px;
  }
</style>